<template>
<transition name="slide" appear>
    <div id="info-wrapper" v-if="visible">
        <div class="info-body">
            <div class="info-head">
                {{popText}}
            </div>
            <button class="close" @click="disableVisibilityParent">
                OK
            </button>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: "InfoPop",
    props: {
        popText: String,
        isTopLeft: Boolean,
    },
    data() {
        return {
            visible: true,
        }
    },
    methods: {
        toggleVisibility() {
            this.visible = !this.visible
        },
        disableVisibilityParent() {
          this.$emit('button', 'interactedInfoPop')
          this.toggleVisibility()
        },
    },
    mounted() {
        //console.log('loaded info')
        if (this.isTopLeft) {
            document.getElementById("info-wrapper").className = "info-wrapper-click-objects";
        } else {
            document.getElementById("info-wrapper").className = "info-wrapper-close-audio";
        }
    }
}
</script>

<style scoped>
.info-wrapper-close-audio,
.info-wrapper-click-objects {
    position: fixed;
    z-index: -1;
    align-content: center;
    background-color: var(--pale);
    border-radius: .5em .5em 0 0;
    width: 100%;
}

.info-wrapper-close-audio {
    bottom: calc(3.5em + .3em);
    right: 0;
    width: 100%;
    border-top: solid 1px var(--darkest);
}

.info-wrapper-click-objects {
    top: 0;
    left: 0;
    border-radius: 0 0 .5em .5em ;
}

.info-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}

.info-wrapper-click-objects .info-body {
    padding-left: 3em;
    width: auto;
}

.info-head {
    display: flex;
    align-items: center;
    margin: 1em;
    justify-content: space-between;
    font-size: .65em;
}

.close {
    top: .35em;
    left: .35em;
    height: 50px;
    width: 50px;
    display: inline;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    cursor: pointer;
    outline: inherit;
    line-height: 1.15;
    padding-right: 1.35em;
    pointer-events: auto;
}


h1 {
    font-size: 1.25em;
    line-height: 1.15;
    padding-left: .5em;
    margin: 1.2em 0 1em;
}

p {
    padding: 0 .5em 3.25em;
    margin: 0 0 1.5em;
}

.button-spacer {
    display: none;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 1s;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
}

@media screen and (min-width: 660px) {
    .info-wrapper {
        max-height: 70vh;
        border-radius: .5em 0 0 0;
    }

    .info-wrapper-close-audio {
        width: 12em;
    }

    .info-wrapper-click-objects {
        width: 16em;
    }

    .info-head {
        margin: .7em 1em;
    }

    .info-wrapper-click-objects .info-body {
        padding-left: 3em;
        width: 12em;
    }

    .button-spacer {
        display: block;
        min-width: 45px;
    }

    h1 {
        font-size: 1.5em;
        padding-left: 0;
    }

    p {
        padding: 0 1em 3.25em;
    }
}
</style>
